import gql from 'graphql-tag';

export const ADD_PRODUCTS_TO_PROJECTS = gql`
	mutation AddProductsToProjects($input: AddProductsToProjectsInput!) {
		addProductsToProjects(input: $input) {
			... on AddProductsToProject {
				cartIds
			}
			... on AddProductsToCartError {
				productErrors {
					variantId
					message
				}
			}
		}
	}
`;
